import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../Styles/TodosnosPreguntan.css";
import FAQs from "./FAQs";

const TodosnosPreguntan = () => {
  const dispatch = useDispatch();
  const { data, fetching } = useSelector((state) => state.InsuranceFAQ);

  useEffect(() => {
    dispatch({ type: "INSURANCE_FAQ_REQUEST" });
  }, [dispatch]);

  const renderFAQs = () => {
    if (fetching || !data) return null;

    return (
      <div className="container tnpaccordion">
        {data.map((faq, index) => (
          <FAQs
            key={index}
            data={faq}
            index={index}
          />
        ))}
      </div>
    );
  };

  return (
    <div id="tnp">
      <h1 className="titulos mt-5">LO QUE TODOS NOS PREGUNTAN</h1>
      <div className="tnp">
        <br />
        <br />
        {renderFAQs()}
        <br />
        <br />
      </div>
    </div>
  );
};

export default TodosnosPreguntan;
